export default {
      id: "clock-usage",
      viewBox: "0 0 18 17",
      url: __webpack_public_path__ + "icons.svg#clock",
      toString: function () {
        return this.url;
      }
    }